import * as actionTypes from './actionTypes';

const initialState = {
    filters: {
        "search": "",
        "filters": {

        },
        "rangeFilters": {

        },
        "sort": {
            "column": "id",
            "order": "asc"
        },
        "additionalFilters": {

        }
    },
    page: 1,
    count: 0,
    items: 10,
    allData: [],
    singleData: []
}

const reducer = (state = initialState, action) => {
    ;
    switch (action.type) {
        case actionTypes.UPDATE_CHECKER_LIST:
            state = {
                ...state,
                allData: action.payload.data,
                count: action.payload.count
            }
            break;
        case actionTypes.UPDATE_SINGLE_CHECKER:
            state = {
                ...state,
                singleData: action.payload,
            }
            break;
        case actionTypes.UPDATE_FILTER:
            state = {
                ...state,
                filters: action.payload,
            }
            break;
        case actionTypes.UPDATE_REDUCER:
            state = {
                ...state,
                [action.payload.item]: action.payload.data,
            }
            break;
        default:
            state = { ...state };
            break;

    }
    ;
    return state;
}

export default reducer;